/*
  Curiosity District – Gift options

  - Scoped per product section
  - Stores wrap + card selections
  - Shows a small selection summary on any [data-gift-trigger]
  - Multi-adds (main + wrap + card) on submit while preserving existing line item properties
    (e.g. message capture inputs already present in the product form)
*/

(function () {
  'use strict';

  /**
   * Message capture (z_gcard_message_capture.liquid)
   *
   * Do NOT rely on inline <script> tags inside snippets because the overlay
   * can be injected via innerHTML (scripts won't execute). This initializer
   * runs from the external asset and binds behavior once per component.
   */
  function initMessageCapture(root) {
    if (!root || root.__cdMsgBound) return;
    root.__cdMsgBound = true;

    // Layout identifier:
    // 0 = none, 1 = classic, 2 = to_from, 3 = blank
    var layoutId = 0;

    function idToLayout(id) {
      if (id === 1) return 'classic';
      if (id === 2) return 'to_from';
      if (id === 3) return 'blank';
      return '';
    }

    function layoutToId(name) {
      if (name === 'classic') return 1;
      if (name === 'to_from') return 2;
      if (name === 'blank') return 3;
      return 0;
    }

    function safe(fn) {
      try { fn(); } catch (e) { /* fail-safe: never break the gift UI */ }
    }

    function notifyGiftSummaryUpdate() {
      // bubble so initGiftUIForSection can hear it
      try {
        root.dispatchEvent(new CustomEvent('cd:gift-summary-update', { bubbles: true }));
      } catch (e) {}
    }

    var layoutBtns = Array.prototype.slice.call(root.querySelectorAll('[data-layout]'));
    var fontSel = root.querySelector('[data-font]');

    var hidden = {
      layout: root.querySelector('[data-prop-layout]'),
      layoutIdNodes: Array.prototype.slice.call(root.querySelectorAll('[data-prop-layout-id]')),
      font: root.querySelector('[data-prop-font]'),
      greeting: root.querySelector('[data-prop-greeting]'),
      body: root.querySelector('[data-prop-body]'),
      signoff: root.querySelector('[data-prop-signoff]'),
      signature: root.querySelector('[data-prop-signature]'),
      message: root.querySelector('[data-prop-message]'),
      messageSign: root.querySelector('[data-prop-message-sign]'),
      to: root.querySelector('[data-prop-to]'),
      from: root.querySelector('[data-prop-from]'),
    };

    function setHiddenAll(nodes, val) {
      if (!nodes || !nodes.length) return;
      nodes.forEach(function (n) { setHidden(n, val); });
    }

    var fields = {
      greeting: root.querySelector('[data-field="greeting"]'),
      body: root.querySelector('[data-field="body"]'),
      signoff: root.querySelector('[data-field="signoff"]'),
      signature: root.querySelector('[data-field="signature"]'),
      messageSign: root.querySelector('[data-field="message_sign"]'),
      to: root.querySelector('[data-field="to"]'),
      from: root.querySelector('[data-field="from"]'),
    };

    function activePreviewRoot() {
      var name = idToLayout(layoutId);
      if (!name) return null;
      return root.querySelector('[data-preview-layout="' + name + '"]');
    }

    var previewCard = root.querySelector('[data-preview-card]');

    var rafClassic = null;
    function scheduleFitClassic() {
      if (rafClassic) cancelAnimationFrame(rafClassic);
      rafClassic = requestAnimationFrame(function () {
        rafClassic = null;
        var p = activePreviewRoot();
        if (p && p.matches('[data-preview-layout="classic"]')) {
          fitClassic(p, { min: 8, max: 48 });
        }
      });
    }

    if (previewCard && 'ResizeObserver' in window) {
      new ResizeObserver(function () {
        scheduleFitClassic();
      }).observe(previewCard);
    }

    function setHidden(node, val) {
      if (!node) return;
      node.value = val == null ? '' : String(val);
    }

    function setText(node, val) {
      if (!node) return;
      var s = (val == null ? '' : String(val));
      node.textContent = s;
      // Use .hidden for broad browser support (instead of toggleAttribute)
      node.hidden = !s.trim();
    }

    function applyFont() {
      var v = (fontSel && fontSel.value) || (hidden.font && hidden.font.value) || 'Trebuchet MS';
      setHidden(hidden.font, v);
      if (previewCard) previewCard.style.setProperty('--cdmsg-font', v);
    }

    function fitClassic(previewRoot, opts) {
      opts = opts || {};
      var min = opts.min == null ? 8 : opts.min;
      var max = opts.max == null ? 34 : opts.max;

      if (!previewRoot) return;

      // If hidden/not laid out yet, skip
      if (previewRoot.clientWidth <= 0 || previewRoot.clientHeight <= 0) return;

    function fits() {
      // scrollHeight/Width tell us if content overflows the box
      return (
        previewRoot.scrollHeight <= previewRoot.clientHeight + 1 &&
        previewRoot.scrollWidth  <= previewRoot.clientWidth  + 1
      );
    }

      var lo = min, hi = max;
      while (lo < hi) {
        var mid = Math.ceil((lo + hi) / 2);
        previewRoot.style.fontSize = mid + 'px';
        if (fits()) lo = mid;
        else hi = mid - 1;
      }
      previewRoot.style.fontSize = lo + 'px';
    }

    function syncClassic() {
      var g = (fields.greeting && fields.greeting.value || '').trim();
      var b = (fields.body && fields.body.value || '').trim();
      var so = (fields.signoff && fields.signoff.value || '').trim();
      var s = (fields.signature && fields.signature.value || '').trim();

      setHidden(hidden.greeting, g);
      setHidden(hidden.body, b);
      setHidden(hidden.signoff, so);
      setHidden(hidden.signature, s);

      var p = activePreviewRoot();
      if (!p) return;
      setText(p.querySelector('[data-preview="greeting"]'), g);
      setText(p.querySelector('[data-preview="body"]'), b);
      setText(p.querySelector('[data-preview="signoff"]'), so);
      setText(p.querySelector('[data-preview="signature"]'), s);

      // Let CSS vertically self-align based on how many fields have content.
      var count = 0;
      if (g) count += 1;
      if (b) count += 1;
      if (so) count += 1;
      if (s) count += 1;
      p.setAttribute('data-classic-count', String(count));
      scheduleFitClassic();
    }

    function syncToFrom() {
      var msg = (fields.messageSign && fields.messageSign.value || '').trim();
      var to = (fields.to && fields.to.value || '').trim();
      var from = (fields.from && fields.from.value || '').trim();


      var box = root.querySelector('.cd-msg__preview-sign');
      var text = root.querySelector('.cd-msg__preview-signText');
      if (box && text) fitTwoLines(box, text, { min: 8, max: 300 });

      new ResizeObserver(function () {
      var box = root.querySelector('.cd-msg__preview-sign');
      var text = root.querySelector('.cd-msg__preview-signText');
      if (box && text) fitTwoLines(box, text, { min: 8, max: 300 });
      }).observe(root.querySelector('.cd-msg__preview-card'));

      // Only one message property should be populated at a time.
      setHidden(hidden.message, '');
      setHidden(hidden.messageSign, msg);
      setHidden(hidden.to, to);
      setHidden(hidden.from, from);

      var p = activePreviewRoot();
      if (!p) return;
      setText(p.querySelector('[data-preview="message_sign"]'), msg);
      setText(p.querySelector('[data-preview="to"]'), to);
      setText(p.querySelector('[data-preview="from"]'), from);
    }

    function applyLayout(nextId) {
      layoutId = typeof nextId === 'number' ? nextId : parseInt(nextId, 10) || 0;
      var layout = idToLayout(layoutId);
      root.setAttribute('data-msg-layout-id', String(layoutId));

      layoutBtns.forEach(function (b) {
        var on = b.getAttribute('data-layout') === layout;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
      });

      setHidden(hidden.layout, layout);
      setHiddenAll(hidden.layoutIdNodes, String(layoutId));

      // Keep the mutually exclusive message property clean.
      if (layoutId === 2) {
        setHidden(hidden.message, '');
      } else {
        setHidden(hidden.messageSign, '');
      }

      
      syncAll();
      if (layoutId === 0) {
        root.setAttribute('data-msg-empty', 'true');
      } else {
        root.removeAttribute('data-msg-empty');
      }
    }

    function syncAll() {
      applyFont();
      if (layoutId === 1) {
        // Classic owns the classic fields; ensure to/from message_sign doesn't leak.
        setHidden(hidden.messageSign, '');
        syncClassic();
      }
      if (layoutId === 2) syncToFrom();
    }

    // Events
    layoutBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        safe(function () {
          var nextName = b.getAttribute('data-layout');
          var nextId = layoutToId(nextName);
          if (nextId === layoutId) return;
          applyLayout(nextId);
          notifyGiftSummaryUpdate();
        });
      });
    });

    if (fontSel) fontSel.addEventListener('change', function () { safe(syncAll); });
          Object.keys(fields).forEach(function (k) {
            if (!fields[k]) return;
            fields[k].addEventListener('input', function () {
        safe(function () {
          syncAll();
          notifyGiftSummaryUpdate();
        });
      });
    });

    // Initial state: respect existing hidden value if present
    safe(function () {
      var firstLayoutIdNode = hidden.layoutIdNodes && hidden.layoutIdNodes[0];
      var initialId = parseInt(firstLayoutIdNode && firstLayoutIdNode.value, 10);
      if (!initialId && hidden.layout && hidden.layout.value) initialId = layoutToId(hidden.layout.value);
      applyLayout(Number.isFinite(initialId) ? initialId : 0);
    });

    //// START ///
function fitTwoLines(container, el, opts) {
  opts = opts || {};
  var min = opts.min == null ? 8 : opts.min;
  var max = opts.max == null ? 300 : opts.max;

  var targetW = container.clientWidth;
  var targetH = container.clientHeight;
  if (targetW <= 0 || targetH <= 0) return;

  // span must be measurable
  el.style.display = 'inline-block';
  el.style.whiteSpace = 'normal';

  // force layout to container size
  el.style.width = targetW + 'px';
  el.style.maxWidth = targetW + 'px';
  el.style.maxHeight = targetH + 'px';

  function fits() {
    return el.scrollWidth <= targetW + 1 && el.scrollHeight <= targetH + 1;
  }

  var lo = min, hi = max;
  while (lo < hi) {
    var mid = Math.ceil((lo + hi) / 2);
    el.style.fontSize = mid + 'px';
    if (fits()) lo = mid;
    else hi = mid - 1;
  }
  el.style.fontSize = lo + 'px';
}

///END///
  }

  function initMessageCaptures(scope) {
    if (!scope) return;
    Array.prototype.slice
      .call(scope.querySelectorAll('[data-cd-msg]'))
      .forEach(function (node) {
        initMessageCapture(node);
      });
  }

  function qs(root, sel) {
    return root ? root.querySelector(sel) : null;
  }

  function qsa(root, sel) {
    return root ? Array.prototype.slice.call(root.querySelectorAll(sel)) : [];
  }

  function uniq(arr) {
    return Array.from(new Set(arr.filter(Boolean)));
  }

  function decodeHtml(str) {
    if (str == null) return '';
    var s = String(str);
    // Decode HTML entities that may come from escaped attributes/options.
    // Example: "Holiday &amp; New Year" vs "Holiday & New Year".
    var t = document.createElement('textarea');
    t.innerHTML = s;
    return t.value;
  }

  function norm(str) {
    return decodeHtml(str || '').toString().trim().toLowerCase();
  }

  function parsePropertiesFromFormData(formData) {
    var props = {};
    formData.forEach(function (val, key) {
      if (!key || typeof key !== 'string') return;
      if (!key.startsWith('properties[')) return;
      var name = key.slice('properties['.length);
      if (name.endsWith(']')) name = name.slice(0, -1);
      if (!name) return;
      props[name] = val;
    });
    return props;
  }

  function collectMessagePropsFromDOM(giftRoot) {
    // NOTE: In "packaging" mode we want a normalized, JS-friendly structure.
    // Return lower-case keys that match the organizer engine expectations.
    var out = {};
    if (!giftRoot) return out;

    var msgRoot = giftRoot.querySelector && giftRoot.querySelector('[data-cd-msg]');
    if (!msgRoot) return out;

    // Persist message layout in a hidden transactional field so previews can render consistently
    // regardless of whether the gift was created from the cart overlay or the packaging organizer.
    try {
      var lidAttr = msgRoot.getAttribute && msgRoot.getAttribute('data-msg-layout-id');
      var lid = parseInt(lidAttr || '', 10);
      if (!isNaN(lid) && lid > 0) out._cd_msg_layout_id = String(lid);
    } catch (e) {}

    function read(sel) {
      var el = msgRoot.querySelector(sel);
      return el ? (el.value == null ? '' : String(el.value)) : '';
    }

    // Read hidden properties (source of truth after initMessageCapture sync).
    out.font = read('[data-prop-font]');
    out.greeting = read('[data-prop-greeting]');
    out.body = read('[data-prop-body]');
    out.signoff = read('[data-prop-signoff]');
    out.signature = read('[data-prop-signature]');
    // "to_from" layout uses data-prop-message-sign; classic/blank may use data-prop-message.
    out.message = (read('[data-prop-message-sign]') || read('[data-prop-message]'));
    out.to = read('[data-prop-to]');
    out.from = read('[data-prop-from]');

    // Trim and drop empties
    Object.keys(out).forEach(function (k) {
      var v = out[k];
      if (v == null) { delete out[k]; return; }
      var s = String(v).trim();
      if (!s) delete out[k];
      else out[k] = s;
    });

    return out;
  }


  function getCart() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function ensurePreviewRoot() {
    var existing = document.querySelector('[data-cd-gift-preview]');
    if (existing) return existing;

    var wrap = document.createElement('div');
    wrap.className = 'cd-gift-preview';
    wrap.setAttribute('data-cd-gift-preview', '');
    wrap.hidden = true;

    wrap.innerHTML =
      '<div class="cd-gift-preview__backdrop" data-cd-gift-preview-close></div>' +
      '<div class="cd-gift-preview__panel" role="dialog" aria-modal="true" aria-label="Image preview" tabindex="-1">' +
      '<button type="button" class="cd-gift-preview__close" aria-label="Close" data-cd-gift-preview-close>✕</button>' +
      '<img src="" alt="" loading="lazy">' +
      '</div>';

    document.body.appendChild(wrap);

    function close() {
      wrap.hidden = true;
      document.documentElement.classList.remove('cd-gift-preview-open');
      var img = wrap.querySelector('img');
      if (img) img.removeAttribute('src');
    }

    wrap.addEventListener('click', function (e) {
      if (e.target && e.target.matches('[data-cd-gift-preview-close]')) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !wrap.hidden) close();
    });

    wrap.__cdClose = close;
    return wrap;
  }

  function openPreview(src, alt) {
    if (!src) return;
    var wrap = ensurePreviewRoot();
    var img = wrap.querySelector('img');
    if (img) {
      img.src = src;
      img.alt = alt || '';
    }
    wrap.hidden = false;
    document.documentElement.classList.add('cd-gift-preview-open');
    var panel = wrap.querySelector('.cd-gift-preview__panel');
    if (panel) panel.focus();
  }

  
  // Portal helpers: move the overlay to <body> while open to avoid being trapped
  // inside transformed/stacked cart containers (which can place it behind header/footer).
  function portalToBody(el) {
    if (!el || !el.parentNode) return;
    if (el.__cdPortal && el.__cdPortal.active) return;

    var parent = el.parentNode;
    var placeholder = document.createComment('cd-gift-overlay-portal');
    try {
      parent.insertBefore(placeholder, el);
    } catch (e) {
      placeholder = null;
    }

    try {
      document.body.appendChild(el);
      el.__cdPortal = { active: true, parent: parent, placeholder: placeholder };
    } catch (e2) {
      // If append fails, keep in place.
      el.__cdPortal = { active: false };
      if (placeholder && placeholder.parentNode) placeholder.parentNode.removeChild(placeholder);
    }
  }

  function restoreFromBody(el) {
    if (!el || !el.__cdPortal || !el.__cdPortal.active) return;
    var p = el.__cdPortal.parent;
    var ph = el.__cdPortal.placeholder;

    try {
      if (ph && ph.parentNode) {
        ph.parentNode.insertBefore(el, ph);
        ph.parentNode.removeChild(ph);
      } else if (p) {
        p.appendChild(el);
      }
    } catch (e) {
      // If restore fails, leave in body.
    }
    el.__cdPortal.active = false;
  }

function openOverlay(root, sectionId) {
    root = root || document;
    var overlay = root.querySelector('[data-gift-overlay][data-section-id="' + sectionId + '"]') || document.querySelector('[data-gift-overlay][data-section-id="' + sectionId + '"]');
    if (!overlay) return;

    // Ensure overlay is not constrained by any cart container stacking context.
    portalToBody(overlay);

    // If the gift overlay is opened from the Packaging Organizer (Split/Change gift boxes),
    // the "Done" button must be hidden. The organizer uses its own Next/Back controls.
    // Detect this by the organizer overlay-open class.
    try {
      var packagingOpen = document.documentElement.classList.contains('cd-packaging--overlay-open');
      var giftRoot = qs(root, '[data-cd-gift][data-section-id="' + sectionId + '"]');
      var doneBtn = overlay.querySelector('.cd-gift__done');
      if (doneBtn) {
        var isPackagingMode = (giftRoot && giftRoot.getAttribute && giftRoot.getAttribute('data-cd-gift-mode') === 'packaging');
        doneBtn.hidden = !!(packagingOpen || isPackagingMode);
      }
    } catch (e) {}
    overlay.hidden = false;
    overlay.classList.add('is-open');
    document.documentElement.classList.add('cd-gift-overlay-open');
    // If overlay content is injected dynamically, bind message capture now.
    initMessageCaptures(overlay);
    var panel = overlay.querySelector('.product__gift-overlay-panel');
    if (panel) panel.focus();
  }

  function closeOverlay(root, sectionId) {
    root = root || document;
    var overlay = root.querySelector('[data-gift-overlay][data-section-id="' + sectionId + '"]') || document.querySelector('[data-gift-overlay][data-section-id="' + sectionId + '"]');
    if (!overlay) return;
    overlay.classList.remove('is-open');
    overlay.hidden = true;
    document.documentElement.classList.remove('cd-gift-overlay-open');
    // Restore overlay back to its original DOM location.
    restoreFromBody(overlay);
  }

  function initGiftUIForSection(sectionId, root) {
    root = root || document.querySelector('product-info[data-section="' + sectionId + '"]');
    if (!root) return;

    var giftRoot = qs(root, '[data-cd-gift][data-section-id="' + sectionId + '"]');
    if (!giftRoot) return;
    if (giftRoot.__cdGiftInited) return;
    giftRoot.__cdGiftInited = true;

    // Initialize message capture behavior (works even if overlay injected later).
    initMessageCaptures(giftRoot);

    var state = {
      wrapVariantId: null,
      wrapImage: null,
      wrapLabel: null,
      cardCode: null,
      cardName: null,
      cardImage: null,
      // message fields are stored as properties on the wrap line item
    };

    function updateChecklist() {
    var check = giftRoot.querySelector('[data-cd-giftcheck]');
    if (!check) return;

    function setDone(key, done) {
      var item = check.querySelector('[data-cd-giftcheck-item="' + key + '"]');
      if (!item) return;
      item.classList.toggle('is-done', !!done);
      item.setAttribute('aria-checked', done ? 'true' : 'false');
    }

    var hasWrap = !!state.wrapVariantId;
    var hasCard = !!state.cardCode;

    // Determine message completion from the *preview* (source of truth for "is it empty?")
    var msgRoot = giftRoot.querySelector('[data-cd-msg]');
    var selectedBtn = msgRoot ? msgRoot.querySelector('.cd-msg__layout-btn[aria-selected="true"]') : null;
    var layout = selectedBtn ? (selectedBtn.getAttribute('data-layout') || '') : '';

    function previewText(layoutName, key) {
      if (!msgRoot) return '';
      var p = msgRoot.querySelector('[data-preview-layout="' + layoutName + '"]');
      if (!p) return '';
      var el = p.querySelector('[data-preview="' + key + '"]');
      if (!el || el.hidden) return '';
      return String(el.textContent || '').trim();
    }

      // classic: at least 1 field filled
      var classicFilled =
        !!previewText('classic', 'greeting') ||
        !!previewText('classic', 'body') ||
        !!previewText('classic', 'signoff') ||
        !!previewText('classic', 'signature');

      // to_from: message + to + from all present
      var toFromFilled =
        !!previewText('to_from', 'message_sign') ||
        !!previewText('to_from', 'to') ||
        !!previewText('to_from', 'from');

      var hasMessage =
        layout === 'blank' ||
        (layout === 'classic' && classicFilled) ||
        (layout === 'to_from' && toFromFilled);

      setDone('wrap', hasWrap);
      setDone('card', hasCard);
      setDone('message', hasMessage);
    }

    if (!giftRoot.__cdGiftSummaryBound)
    {
          giftRoot.__cdGiftSummaryBound = true;
          giftRoot.addEventListener('cd:gift-summary-update', function () {
            updateTriggers();
            updateChecklist();
            updateClearBtn();
          });
        }


    // Ensure checklist updates while typing, even if custom events don't fire in some injected DOM cases.
    if (!giftRoot.__cdGiftChecklistLiveBound) {
      giftRoot.__cdGiftChecklistLiveBound = true;

      giftRoot.addEventListener('input', function (e) {
        var t = e && e.target;
        if (t && t.closest && t.closest('[data-cd-msg]')) {
          window.requestAnimationFrame(updateChecklist);
          window.requestAnimationFrame(updateClearBtn);
        }
      }, true);

      giftRoot.addEventListener('change', function (e) {
        var t = e && e.target;
        if (t && t.closest && t.closest('[data-cd-msg]')) {
          window.requestAnimationFrame(updateChecklist);
          window.requestAnimationFrame(updateClearBtn);
        }
      }, true);

      giftRoot.addEventListener('click', function (e) {
        var t = e && e.target;
        if (t && t.closest && t.closest('.cd-msg__layout-btn')) {
          window.requestAnimationFrame(updateChecklist);
          window.requestAnimationFrame(updateClearBtn);
        }
      }, true);
      }

    var isPackagingMode = !!(root && root.getAttribute && root.getAttribute('data-cd-gift-mode') === 'packaging');
    // Cart context (gift overlay inside cart)
    var isCartContext = !!(root && (root.hasAttribute && root.hasAttribute('data-cd-gift-cart')));

    function cartGetJSON(url) {
      return fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.json(); });
    }

    function parseStateFromWrapLine(item) {
      if (!item) return {};
      var props = item.properties || {};

      var code = (props._cd_card_code || '').toString().trim();
      var name = (props._cd_card_name || '').toString().trim();
      if ((!code || !name) && props['Greeting card']) {
        var raw = String(props['Greeting card']);
        var parts = raw.split(' - ');
        if (!code && parts[0]) code = String(parts[0]).trim();
        if (!name && parts.slice(1).join(' - ')) name = parts.slice(1).join(' - ').trim();
      }

      function pick() {
        for (var i = 0; i < arguments.length; i++) {
          var k = arguments[i];
          if (props[k] != null && String(props[k]).trim() !== '') return String(props[k]);
        }
        return '';
      }

      var layoutId = 0;
      var lid = (props._cd_msg_layout_id != null ? props._cd_msg_layout_id : (props['Message layout id'] != null ? props['Message layout id'] : ''));
      if (lid !== '' && lid != null) {
        var n = parseInt(String(lid), 10);
        if (!isNaN(n)) layoutId = n;
      }

      return {
        wrapVariantId: item.variant_id ? String(item.variant_id) : null,
        cardCode: code || null,
        cardName: name || null,
        cardImage: pick('_cd_card_image') || null,
        layoutId: layoutId || 0,
        font: pick('Card font', 'font') || '',
        greeting: pick('Greeting', 'greeting') || '',
        body: pick('Body', 'body') || '',
        signoff: pick('Sign-off', 'signoff') || '',
        signature: pick('Signature', 'signature') || '',
        message: pick('Message', 'message', 'message_sign') || '',
        to: pick('To', 'to') || '',
        from: pick('From', 'from') || ''
      };
    }

    function applyStateToUI(next) {
      next = next || {};

      function raf(fn) {
        try { window.requestAnimationFrame(fn); } catch (e) { setTimeout(fn, 0); }
      }
      function clickSel(selector) {
        var el = giftRoot.querySelector(selector);
        if (!el) return;
        try { el.click(); } catch (e) {}
      }
      function setField(msgRoot, key, val) {
        var el = msgRoot.querySelector('[data-field="' + key + '"]');
        if (!el) return;
        el.value = (val == null ? '' : String(val));
        try { el.dispatchEvent(new Event('input', { bubbles: true })); } catch (e) {}
        try { el.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {}
      }

      // Keep internal state in sync too
      state.wrapVariantId = next.wrapVariantId || null;
      state.cardCode = next.cardCode || null;
      state.cardName = next.cardName || null;
      state.cardImage = next.cardImage || null;

      raf(function () {
        clickSel('[data-cd-giftclear]');
        raf(function () {
          if (next.wrapVariantId) clickSel('[data-giftwrap-swatch][data-variant-id="' + String(next.wrapVariantId) + '"]');
          raf(function () {
            if (next.cardCode) clickSel('[data-giftcard-item][data-card-code="' + String(next.cardCode) + '"]');
            raf(function () {
              var msgRoot = giftRoot.querySelector('[data-cd-msg]');
              var lid = parseInt(next.layoutId || 0, 10) || 0;
              if (msgRoot && lid) {
                var layoutName = lid === 1 ? 'classic' : (lid === 2 ? 'to_from' : (lid === 3 ? 'blank' : ''));
                if (layoutName) clickSel('[data-cd-msg] .cd-msg__layout-btn[data-layout="' + layoutName + '"]');
                raf(function () {
                  setField(msgRoot, 'greeting', next.greeting);
                  setField(msgRoot, 'body', next.body);
                  setField(msgRoot, 'signoff', next.signoff);
                  setField(msgRoot, 'signature', next.signature);
                  setField(msgRoot, 'message_sign', next.message);
                  setField(msgRoot, 'to', next.to);
                  setField(msgRoot, 'from', next.from);
                  var fontSel = msgRoot.querySelector('[data-font]');
                  if (fontSel && next.font) {
                    fontSel.value = String(next.font);
                    try { fontSel.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {}
                  }
                  updateTriggers();
                  updateChecklist();
                  updateClearBtn();
                });
              } else {
                updateTriggers();
                updateChecklist();
                updateClearBtn();
              }
            });
          });
        });
      });
    }

    function preloadFromCartAndApply() {
      if (!isCartContext || isPackagingMode) return Promise.resolve();
      var pkgHost = giftRoot && giftRoot.closest ? giftRoot.closest('[data-cd-gift-cart]') : null;
      var packageId = (pkgHost && pkgHost.getAttribute('data-gift-package')) ? String(pkgHost.getAttribute('data-gift-package')) : '1';

      return cartGetJSON('/cart.js').then(function (cart) {
        var found = null;
        (cart.items || []).forEach(function (it) {
          var props = it && it.properties ? it.properties : null;
          if (!props) return;
          if (String(props._cd_gift_type || '') !== 'wrap') return;
          if (String(props._cd_gift_package || '') !== packageId) return;
          found = it;
        });
        if (found) {
          var st = parseStateFromWrapLine(found);
          applyStateToUI(st);
        }
      }).catch(function () { /* silent */ });
    }


    // Wire open/close for desktop triggers (mobile is already handled by product-sticky-bar.js)
    // In packaging mode the gift UI is embedded inside the packaging organizer overlay,
    // so we must NOT open/close a separate overlay.
    if (!isPackagingMode) {
      qsa(root, '[data-gift-overlay-open]').forEach(function (btn) {
        if (btn.__cdGiftOpenBound) return;
        btn.__cdGiftOpenBound = true;
        btn.addEventListener('click', function () {
          // When opening from the cart, preload selections from the existing wrap line item (if any).
          if (typeof preloadFromCartAndApply === 'function') {
            try {
              preloadFromCartAndApply().finally(function () { openOverlay(root, sectionId); });
            } catch (e) {
              openOverlay(root, sectionId);
            }
          } else {
            openOverlay(root, sectionId);
          }
        });
      });

      qsa(root, '[data-gift-overlay-close]').forEach(function (el) {
        if (el.__cdGiftCloseBound) return;
        el.__cdGiftCloseBound = true;
        el.addEventListener('click', function () {
          closeOverlay(root, sectionId);
        });
      });
    }

// --- Cart context support ---
// If this gift UI is rendered inside the cart, we "apply" selections when the user clicks Done,
// instead of intercepting a product form submit.
// var isCartContext = !!(root && (root.hasAttribute && root.hasAttribute('data-cd-gift-cart')));

// Prevent Dawn cart quantity validation (assets/cart.js) from reacting to overlay dropdown changes.
// IMPORTANT: use bubble-phase stopPropagation so internal giftRoot handlers still run.
if (isCartContext && !isPackagingMode) {
  var cartOverlay = root.querySelector('[data-gift-overlay][data-section-id="' + sectionId + '"]') || root.querySelector('[data-gift-overlay]');
  if (cartOverlay && !cartOverlay.__cdCartStopBound) {
    cartOverlay.__cdCartStopBound = true;
    ['change', 'input'].forEach(function (evtName) {
      cartOverlay.addEventListener(evtName, function (e) {
        // Let the event reach giftRoot handlers, but do not let it bubble to <cart-items>.
        e.stopPropagation();
      }, false);
    });
  }

  var doneBtn = giftRoot.querySelector('.cd-gift__done[data-gift-overlay-close]');
  if (doneBtn && !doneBtn.__cdCartDoneBound) {
    doneBtn.__cdCartDoneBound = true;

    function cartFetchJSON(url, bodyObj) {
      return fetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(bodyObj || {})
      }).then(function (r) { return r.json(); });
    }

    function cartGetJSON(url) {
      return fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.json(); });
    }

    function normalizeId(v) {
      var n = Number(v);
      return Number.isFinite(n) ? n : null;
    }

    doneBtn.addEventListener('click', function (e) {
      // Capture-phase: override the generic [data-gift-overlay-close] click binding above.
      e.preventDefault();
      e.stopImmediatePropagation();

      if (giftRoot) { var _err = giftRoot.querySelector('[data-gift-error]'); if (_err) { _err.hidden = true; _err.textContent=''; } }

      var wrapId = normalizeId(state.wrapVariantId);
      var cardCode = (state.cardCode || '').trim();
      var cardName = (state.cardName || '').trim();

      var hasMsg = anyMessageSelected();

      if (!wrapId || !cardCode || !cardName || !hasMsg) {
        var msg = giftRoot.getAttribute('data-error-incomplete') ||
          'Please select wrapping paper, card, and message options before applying.';
        if (giftRoot) { var _err2 = giftRoot.querySelector('[data-gift-error]'); if (_err2) { _err2.textContent = msg; _err2.hidden = false; } else { window.alert(msg); } }
        openOverlay(root, sectionId);
        updateChecklist();
        return;
      }

      // Apply to cart: current package (set by Cart Packages UI)
      var pkgHost = giftRoot && giftRoot.closest ? giftRoot.closest('[data-cd-gift-cart]') : null;
      var packageId = (pkgHost && pkgHost.getAttribute('data-gift-package')) ? String(pkgHost.getAttribute('data-gift-package')) : '1';

      doneBtn.setAttribute('aria-busy', 'true');
      doneBtn.disabled = true;

      cartGetJSON('/cart.js')
        .then(function (cart) {
          var updates = {};
          (cart.items || []).forEach(function (item) {
            var props = item && item.properties ? item.properties : null;
            var t = props ? String(props._cd_gift_type || '') : '';
            // Only remove existing gift components for this package.
            if (props && String(props._cd_gift_package || '') === packageId && (t === 'wrap' || t === 'card' || t === 'message')) {
              updates[item.key] = 0;
            }
          });
          if (Object.keys(updates).length) {
            return cartFetchJSON('/cart/update.js', { updates: updates });
          }
          return cart;
        })
        .then(function () {
          var msgProps = collectMessagePropsFromDOM(giftRoot);

          var items = [
            {
              id: wrapId,
              quantity: 1,
              properties: Object.assign({
                _cd_gift_package: packageId,
                _cd_gift_type: 'wrap',
                // Visible human-readable selection
                'Greeting card': String(cardCode) + ' - ' + String(cardName),
                // Hidden transactional fields
                _cd_card_code: String(cardCode),
                _cd_card_name: String(cardName),
                _cd_card_image: String(state.cardImage || '')
              }, msgProps)
            }
          ];

          return cartFetchJSON('/cart/add.js', { items: items });
        })
        .then(function () {
          closeOverlay(root, sectionId);
          window.location.reload();
        })
        .catch(function (err) {
          console.error('[CD Cart Gift] Apply failed:', err);
          if (giftRoot) { var _err3 = giftRoot.querySelector('[data-gift-error]'); if (_err3) { _err3.textContent = 'Something went wrong. Please try again.'; _err3.hidden = false; } else { window.alert('Something went wrong. Please try again.'); } }
          openOverlay(root, sectionId);
        })
        .finally(function () {
          doneBtn.removeAttribute('aria-busy');
          doneBtn.disabled = false;
        });
    }, true);
  }
}

// --- Packaging organizer mode support ---
// When embedded in the packaging organizer, this component must:
// - never mutate the cart
// - expose get/set helpers for preloading
// - emit the current selection state on every meaningful change
if (isPackagingMode) {
  // Hide/disable any "Done" buttons that are meant to apply to cart.
  var done = giftRoot.querySelector('.cd-gift__done');
  if (done) done.hidden = true;

  // Extra safety: if this UI is rendered anywhere inside the cart drawer DOM,
  // prevent events from reaching <cart-items> (Dawn) listeners.
  // IMPORTANT: use bubble-phase so internal UI handlers still receive events.
  if (!giftRoot.__cdPackagingStopBound) {
    giftRoot.__cdPackagingStopBound = true;
    ['change', 'input', 'click', 'submit'].forEach(function (evtName) {
      giftRoot.addEventListener(evtName, function (e) {
        if (!e) return;
        e.stopPropagation();
      }, false);
    });
  }

  function readLayoutId() {
    var msgRoot = giftRoot.querySelector('[data-cd-msg]');
    if (!msgRoot) return 0;
    var v = msgRoot.getAttribute('data-msg-layout-id');
    var n = parseInt(v, 10);
    return isNaN(n) ? 0 : n;
  }

  function getCurrentState() {
    var msg = collectMessagePropsFromDOM(giftRoot);
    return Object.assign({
      wrapVariantId: state.wrapVariantId || null,
      cardCode: state.cardCode || null,
      cardName: state.cardName || null,
      cardImage: state.cardImage || null,
      layoutId: readLayoutId()
    }, msg || {});
  }

  function emitState() {
    try {
      giftRoot.dispatchEvent(new CustomEvent('cd:packaging-gift-state', {
        bubbles: true,
        detail: { state: getCurrentState() }
      }));
    } catch (e) {}
  }

  // Public helpers for organizer to preload selections.
  giftRoot.__cdGiftGetState = function () { return getCurrentState(); };
  giftRoot.__cdGiftSetState = function (next) {
    next = next || {};

    // Accept both normalized (lowercase) and legacy/serialized (Title Case) keys.
    function pick() {
      for (var i = 0; i < arguments.length; i++) {
        var k = arguments[i];
        if (!k) continue;
        if (Object.prototype.hasOwnProperty.call(next, k) && next[k] != null) return next[k];
      }
      return '';
    }

    // Ensure package switching is deterministic AND reliable across browsers:
    // apply in a small RAF sequence so the UI has time to react to each click.
    function raf(fn) {
      try { window.requestAnimationFrame(fn); } catch (e) { setTimeout(fn, 0); }
    }

    function clickSel(selector) {
      var el = giftRoot.querySelector(selector);
      if (!el) return;
      try { el.click(); } catch (e) {}
    }

    function setMessageFields(msgRoot) {
      if (!msgRoot) return;
      function setField(key, val) {
        var el = msgRoot.querySelector('[data-field="' + key + '"]');
        if (!el) return;
        el.value = (val == null ? '' : String(val));
        try { el.dispatchEvent(new Event('input', { bubbles: true })); } catch (e) {}
        try { el.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {}
      }
      setField('greeting', pick('greeting', 'Greeting'));
      setField('body', pick('body', 'Body'));
      setField('signoff', pick('signoff', 'Sign-off', 'Signoff'));
      setField('signature', pick('signature', 'Signature'));
      setField('message_sign', pick('message', 'Message', 'messageSign', 'Message sign'));
      setField('to', pick('to', 'To'));
      setField('from', pick('from', 'From'));
    }

    // Step 1: clear
    raf(function () {
      clickSel('[data-cd-giftclear]');

      // Step 2: wrap
      raf(function () {
        if (next.wrapVariantId) {
          clickSel('[data-giftwrap-swatch][data-variant-id="' + String(next.wrapVariantId) + '"]');
        }

        // Step 3: card
        raf(function () {
          if (next.cardCode) {
            clickSel('[data-giftcard-item][data-card-code="' + String(next.cardCode) + '"]');
          }

          // Step 4: message layout + fields
          raf(function () {
            var msgRoot = giftRoot.querySelector('[data-cd-msg]');
            var lid = parseInt(pick('layoutId', 'LayoutId'), 10);
            if (!lid && next['Message layout']) {
              var ml = String(next['Message layout']).toLowerCase();
              lid = ml === 'classic' ? 1 : (ml === 'to_from' ? 2 : (ml === 'blank' ? 3 : 0));
            }
            if (msgRoot && lid) {
              var layoutName = lid === 1 ? 'classic' : (lid === 2 ? 'to_from' : (lid === 3 ? 'blank' : ''));
              if (layoutName) {
                clickSel('[data-cd-msg] .cd-msg__layout-btn[data-layout="' + layoutName + '"]');
              }
              // Give the layout one more frame to render its fields before setting values.
              raf(function () {
                setMessageFields(msgRoot);
                emitState();
              });
              return;
            }

            // No message layout selected.
            emitState();
          });
        });
      });
    });
  };

  // Emit on any state-changing interaction.
  giftRoot.addEventListener('click', function (e) {
    var t = e && e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-giftwrap-swatch]') || t.closest('[data-giftcard-item]') || t.closest('.cd-msg__layout-btn')) {
      window.requestAnimationFrame(emitState);
    }
  }, true);

  giftRoot.addEventListener('input', function (e) {
    var t = e && e.target;
    if (t && t.closest && t.closest('[data-cd-msg]')) {
      window.requestAnimationFrame(emitState);
    }
  }, true);

  giftRoot.addEventListener('change', function (e) {
    var t = e && e.target;
    if (t && t.closest && t.closest('[data-cd-msg]')) {
      window.requestAnimationFrame(emitState);
    }
  }, true);

  // Initial emit
  window.requestAnimationFrame(emitState);
}
    var clearBtn = qs(giftRoot, '[data-cd-giftclear]');

    function anyMessageSelected() {
      // mirror your tick logic (safe + reliable)
      var msgRoot = giftRoot.querySelector('[data-cd-msg]');
      if (!msgRoot) return false;

      var selectedBtn = msgRoot.querySelector('.cd-msg__layout-btn[aria-selected="true"]');
      var layout = selectedBtn ? (selectedBtn.getAttribute('data-layout') || '') : '';

      function readField(key) {
        var el = msgRoot.querySelector('[data-field="' + key + '"]');
        return el ? String(el.value || '').trim() : '';
      }

      var classicFilled =
        !!readField('greeting') ||
        !!readField('body') ||
        !!readField('signoff') ||
        !!readField('signature');

      var toFromFilled =
        !!readField('message_sign') ||
        !!readField('to') ||
        !!readField('from'); // <-- any field (per your latest requirement)

      return (
        layout === 'blank' ||
        (layout === 'classic' && classicFilled) ||
        (layout === 'to_from' && toFromFilled)
      );
    }

    function updateClearBtn() {
      if (!clearBtn) return;
      var hasAnything = !!state.wrapVariantId || !!state.cardCode || anyMessageSelected();
      clearBtn.hidden = !hasAnything;
    }

    function clearSelections() {
      // 1) Clear wrap UI + state
      var wrapBtns = qsa(giftRoot, '[data-giftwrap-swatch]');
      wrapBtns.forEach(function (b) { setPressed(b, false); });
      state.wrapVariantId = null;
      state.wrapImage = null;
      state.wrapLabel = null;
      updateWrapPriceUI(giftRoot, null);


      // 2) Clear card UI + state
      var cardBtns = qsa(giftRoot, '[data-giftcard-item]');
      cardBtns.forEach(function (b) { setPressed(b, false); });
      state.cardCode = null;
      state.cardName = null;
      state.cardLabel = null;
      state.cardImage = null;

      // 3) Clear message inputs + try to de-select layout
      var msgRoot = giftRoot.querySelector('[data-cd-msg]');
      if (msgRoot) {
        // clear text fields (triggers your preview sync because you already listen to input)
        qsa(msgRoot, '[data-field]').forEach(function (el) {
          if (el && 'value' in el) {
            el.value = '';
            el.dispatchEvent(new Event('input', { bubbles: true }));
            el.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });

        // de-select layout buttons (if your UI supports "none" this will effectively reset)
        qsa(msgRoot, '.cd-msg__layout-btn').forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-selected', 'false');
        });

        // also clear hidden layout property if present
        var propLayout = msgRoot.querySelector('[data-prop-layout]');
        if (propLayout) propLayout.value = '';
        qsa(msgRoot, '[data-prop-layout-id]').forEach(function (n) { n.value = ''; });
      }

      // Refresh UI
      updateTriggers();
      updateChecklist();
      updatePreview('wrap');
      updatePreview('card');
      updateClearBtn();

      // Let anything else listening update too
      try {
        giftRoot.dispatchEvent(new CustomEvent('cd:gift-summary-update', { bubbles: true }));
      } catch (e) {}

      // CART ONLY: if the overlay is being used in the cart, clearing selections means
      // removing the gift bundle (wrap + card + message) for the current package from the cart.
      var pkgHost = giftRoot && giftRoot.closest ? giftRoot.closest('[data-cd-gift-cart]') : null;
      var packageId = (pkgHost && pkgHost.getAttribute('data-gift-package')) ? String(pkgHost.getAttribute('data-gift-package')) : '';
      if (pkgHost && packageId) {
        var _mode = pkgHost.getAttribute && pkgHost.getAttribute('data-cd-gift-mode');
        if (_mode === 'packaging') return;
        if (typeof cartGetJSON !== 'function') return;
        cartGetJSON('/cart.js')
          .then(function (cart) {
            var updates = {};
            (cart.items || []).forEach(function (item) {
              var props = item && item.properties ? item.properties : null;
              var t = props ? String(props._cd_gift_type || '') : '';
              if (props && String(props._cd_gift_package || '') === packageId && (t === 'wrap' || t === 'card' || t === 'message')) {
                updates[item.key] = 0;
              }
            });
            if (Object.keys(updates).length) {
              return cartFetchJSON('/cart/update.js', { updates: updates });
            }
            return cart;
          })
          .then(function () { window.location.reload(); })
          .catch(function () { window.location.reload(); });
      }
    }

    if (clearBtn && !clearBtn.__cdBound) {
      clearBtn.__cdBound = true;
      clearBtn.addEventListener('click', clearSelections);
    }


    function setPressed(el, pressed) {
      if (!el) return;
      el.setAttribute('aria-pressed', pressed ? 'true' : 'false');
      el.classList.toggle('is-selected', !!pressed);
    }

    function formatMoneyFromCents(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        const fmt = window.theme?.moneyFormat || window.Shopify.money_format || '${{amount}}';
        return window.Shopify.formatMoney(cents, fmt);
      }
      return `$${(cents / 100).toFixed(2)}`;
    }

    function updateWrapPriceUI(giftRoot, selectedCents) {
      // Header price next to Occasion
      const titlePrice = giftRoot.querySelector('[data-wrap-title-price]');
      if (titlePrice) {
        titlePrice.hidden = !(selectedCents > 0);
        titlePrice.textContent = selectedCents > 0 ? `  ${formatMoneyFromCents(selectedCents)}` : '';
      }

      // Progress/edit bar price
      const checkPrice = giftRoot.querySelector('[data-wrap-check-price]');
      if (checkPrice) {
        checkPrice.hidden = !(selectedCents > 0);
        checkPrice.textContent = selectedCents > 0 ? `(${formatMoneyFromCents(selectedCents)})` : '';
      }

      // Deltas on swatches
      const swatches = giftRoot.querySelectorAll('[data-giftwrap-swatch][data-price-cents]');
      swatches.forEach((btn) => {
        const cents = parseInt(btn.getAttribute('data-price-cents') || '0', 10);
        const deltaEl = btn.querySelector('[data-wrap-delta]');
        if (!deltaEl) return;

        // If nothing selected yet, compare to $0
        const baseCents = (selectedCents == null || isNaN(selectedCents)) ? 0 : selectedCents;

        const isSelected = btn.getAttribute('aria-pressed') === 'true';
        const delta = cents - baseCents;

        // If something IS selected, keep your old behavior: hide on selected + hide when delta=0
        if (baseCents !== 0 && (isSelected || delta === 0)) {
          deltaEl.hidden = true;
          deltaEl.textContent = '';
          return;
        }

        // Before any selection (baseCents === 0): show deltas vs $0
        // Show $0.00 for free options, +$X for paid ones
        if (delta === 0) {
          deltaEl.hidden = false;
          deltaEl.textContent = formatMoneyFromCents(0); // "$0.00"
          return;
        }

        const sign = delta > 0 ? '+' : '−';
        deltaEl.hidden = false;
        deltaEl.textContent = `${sign}${formatMoneyFromCents(Math.abs(delta))}`;
      });

    }

    function updatePreview(kind) {
      // kind: 'wrap' | 'card'
      var preview = qs(giftRoot, kind === 'wrap' ? '[data-giftwrap-preview]' : '[data-giftcard-preview]');
      if (!preview) return;

      var imgEl = qs(preview, kind === 'wrap' ? '[data-giftwrap-preview-img]' : '[data-giftcard-preview-img]');
      var titleEl = qs(preview, kind === 'wrap' ? '[data-giftwrap-preview-title]' : '[data-giftcard-preview-title]');
      var placeholderEl = qs(preview, kind === 'wrap' ? '[data-giftwrap-preview-placeholder]' : '[data-giftcard-preview-placeholder]');
      var zoomBtn = qs(preview, '[data-cd-preview-zoom]');

      var src = kind === 'wrap' ? state.wrapImage : state.cardImage;
      // Some flows only populate cardName; keep preview resilient.
      var label = kind === 'wrap' ? state.wrapLabel : (state.cardLabel || state.cardName);

      if (titleEl) titleEl.textContent = label || '';
      if (imgEl) {
        // Avoid showing a broken-image icon while the image loads.
        imgEl.onload = null;
        imgEl.onerror = null;
        // Reset
        imgEl.hidden = true;
        imgEl.removeAttribute('src');

        if (src) {
          // In overlays (and after package switching), lazy loading + `hidden` can prevent
          // the request from firing promptly in some browsers.
          try { imgEl.loading = 'eager'; } catch (e) {}

          // IMPORTANT: don't keep the image `hidden` while loading.
          imgEl.hidden = false;
          if (placeholderEl) placeholderEl.hidden = false;

          imgEl.onload = function () {
            imgEl.hidden = false;
            if (placeholderEl) placeholderEl.hidden = true;
            var media = imgEl.closest('.cd-giftpreview__media');
            if (media) media.classList.add('is-clickable');
          };
          imgEl.onerror = function () {
            imgEl.hidden = true;
            imgEl.removeAttribute('src');
            if (placeholderEl) placeholderEl.hidden = false;
            var media2 = imgEl.closest('.cd-giftpreview__media');
            if (media2) media2.classList.remove('is-clickable');
          };
          imgEl.src = src;
          imgEl.alt = label || '';

          // Handle cached images where onload may not fire (Safari)
          window.requestAnimationFrame(function () {
            try {
              if (imgEl.complete && imgEl.naturalWidth > 0) imgEl.onload();
            } catch (e) {}
          });
        } else {
          var media3 = imgEl.closest('.cd-giftpreview__media');
          if (media3) media3.classList.remove('is-clickable');
          if (placeholderEl) placeholderEl.hidden = false;
        }
      }
      if (zoomBtn) zoomBtn.hidden = !src;
    }

    function updateTriggers() {
      var triggers = qsa(root, '[data-gift-trigger]');
      var summaryParts = [];

      if (state.wrapVariantId && state.wrapImage) {
        summaryParts.push('<span class="cd-gift-thumb" title="' + (state.wrapLabel || '') + '"><img src="' + state.wrapImage + '" alt="" loading="lazy"></span>');
      }
      if (state.cardCode && state.cardImage) {
        summaryParts.push('<span class="cd-gift-thumb" title="' + (state.cardLabel || '') + '"><img src="' + state.cardImage + '" alt="" loading="lazy"></span>');
      }

      (function addSelectedLayoutThumb() {
var selectedBtn = giftRoot.querySelector('.cd-msg__layout-btn[aria-selected="true"]');
    if (!selectedBtn) return;

    var img = selectedBtn.querySelector('.cd-msg__thumb img');
    if (!img) return;



    var clone = img.cloneNode(true);
    clone.removeAttribute('width');
    clone.removeAttribute('height');

    summaryParts.push(
      '<span class="cd-gift-thumb cd-gift-thumb--layout" title="Message layout">' +
        clone.outerHTML +
      '</span>'
    );

    

  })();
     
      triggers.forEach(function (t) {
        var labelEl = t.querySelector('.product__gift-trigger-label');
        var summaryEl = t.querySelector('[data-gift-trigger-summary]');
        var iconEl = t.querySelector('.product__gift-trigger-icon');
        var emptyLabel = t.getAttribute('data-label-empty') || 'Gift options';
        var editLabel = t.getAttribute('data-label-edit') || 'Edit gift options';

        if (summaryParts.length) {
          if (labelEl) labelEl.textContent = editLabel;
          if (summaryEl) {
            summaryEl.hidden = false;
            summaryEl.innerHTML = summaryParts.join('');
          }
          // Hide the gift icon once a selection exists (per UX requirement)
          if (iconEl) iconEl.hidden = true;
        } else {
          if (labelEl) labelEl.textContent = emptyLabel;
          if (summaryEl) {
            summaryEl.hidden = true;
            summaryEl.innerHTML = '';
          }
          if (iconEl) iconEl.hidden = false;
        }
      });
    }

    // Filtering (delegated) – works even if overlay HTML is re-rendered
    function splitOccasions(raw) {
      var s = (raw || '').toString();
      var parts = s.indexOf('||') >= 0 ? s.split('||') : s.split(',');
      return parts.map(norm).filter(Boolean);
    }

    function applyFilter(target, value) {
      var want = norm(value);
      var scope = giftRoot.querySelector('[data-cd-filter-scope="' + target + '"]') || giftRoot;
      var tiles = qsa(scope, '[data-cd-gift-tile]');
      tiles.forEach(function (tile) {
        var occs = splitOccasions(tile.getAttribute('data-occasions'));
        var show = want === '__all__' || !want || occs.length === 0 || occs.indexOf(want) >= 0;
        tile.hidden = !show;
        tile.classList.toggle('cd-is-hidden', !show);
      });
    }

    // Debug helper (call from console)
    giftRoot.CD_applyGiftFilter = function (target, value) {
      applyFilter(target, value);
    };

    giftRoot.addEventListener('change', function (e) {
      var sel = e.target && e.target.closest ? e.target.closest('[data-cd-occasion-select]') : null;
      if (!sel) return;
      var target = sel.getAttribute('data-target');
      if (!target) return;
      applyFilter(target, sel.value);
    });

    // Initialize filters based on current dropdown values
    qsa(giftRoot, '[data-cd-occasion-select]').forEach(function (sel) {
      var target = sel.getAttribute('data-target');
      if (!target) return;
      applyFilter(target, sel.value);
    });

    // Wrap selector behavior (z_gift_wrap_selector)
    var wrapRoot = qs(giftRoot, '[data-giftwrap]');
    function hydrateInitialSelection(kindRoot, buttonSelector, setFn) {
      if (!kindRoot) return;
      var btn =
        kindRoot.querySelector(buttonSelector + '[aria-pressed="true"]') ||
        kindRoot.querySelector(buttonSelector + '.is-selected') ||
        kindRoot.querySelector(buttonSelector + '[data-selected="true"]');
      if (btn) setFn(btn);
    }

    if (wrapRoot) {
      var wrapButtons = qsa(wrapRoot, '[data-giftwrap-swatch]');

      function applyWrapButton(b) {
        wrapButtons.forEach(function (x) {
          setPressed(x, false);
        });
        setPressed(b, true);

        state.wrapVariantId = b.getAttribute('data-variant-id') || null;
        state.wrapLabel = (b.getAttribute('title') || '').trim();
        var img = b.querySelector('img');
        var wrapImageAttr = (b.getAttribute('data-wrap-image') || '').trim();
        state.wrapImage = wrapImageAttr || (img ? img.getAttribute('src') : null);
        updateTriggers();
        updateChecklist();
        updateClearBtn();
        updatePreview('wrap');
        var selectedCents = parseInt(b.getAttribute('data-price-cents') || '0', 10);
        updateWrapPriceUI(giftRoot, selectedCents);
      }

      wrapButtons.forEach(function (b) {
        b.addEventListener('click', function () {
          applyWrapButton(b);
        });
      });

      hydrateInitialSelection(wrapRoot, '[data-giftwrap-swatch]', applyWrapButton);
      updateClearBtn();
    }

    // Card selector behavior
    var cardRoot = qs(giftRoot, '[data-giftcard]');
    if (cardRoot) {
      var cardButtons = qsa(cardRoot, '[data-giftcard-item]');

      function applyCardButton(b) {
        cardButtons.forEach(function (x) {
          setPressed(x, false);
        });
        setPressed(b, true);

        state.cardCode = (b.getAttribute('data-card-code') || '').trim() || null;
        state.cardName = (b.getAttribute('data-card-name') || '').trim() || null;
        state.cardLabel = state.cardName;
        var imgAttr = (b.getAttribute('data-card-image') || '').trim();
        if (imgAttr) {
          state.cardImage = imgAttr;
        } else {
          var img = b.querySelector('img');
          state.cardImage = img ? (img.getAttribute('src') || img.getAttribute('data-src') || '') : null;
          state.cardImage = state.cardImage ? String(state.cardImage) : null;
        }
        updateTriggers();
        updateChecklist();
        updatePreview('card');
        updateClearBtn();
        updateChecklist();
      }

      cardButtons.forEach(function (b) {
        b.addEventListener('click', function () {
          applyCardButton(b);
        });
      });

      hydrateInitialSelection(cardRoot, '[data-giftcard-item]', applyCardButton);
      updateClearBtn();
    }

    // Preview zoom (only from preview area / zoom icon)
    giftRoot.addEventListener('click', function (e) {
      var zoom = e.target && e.target.closest ? e.target.closest('[data-cd-preview-zoom]') : null;
      var media = e.target && e.target.closest ? e.target.closest('.cd-giftpreview__media.is-clickable') : null;
      if (!zoom && !media) return;
      var kind = (zoom && zoom.getAttribute('data-kind')) || (media && (media.closest('[data-giftwrap-preview]') ? 'wrap' : 'card'));
      if (kind === 'wrap') {
        openPreview(state.wrapImage, state.wrapLabel);
      } else {
        openPreview(state.cardImage, state.cardLabel);
      }
    });

    // Mobile step navigation (makes horizontal scrolling clear)
    /*
    (function initGiftNav() {
      var stepsEl = qs(giftRoot, '[data-cd-gift-steps]');
      var nav = qs(giftRoot, '[data-cd-gift-nav]');
      if (!stepsEl || !nav) return;

      var steps = qsa(stepsEl, '[data-cd-gift-step]');
      if (!steps.length) return;

      var dots = qsa(nav, '[data-cd-gift-nav-dot]');
      var prevBtn = qs(nav, '[data-cd-gift-nav-prev]');
      var nextBtn = qs(nav, '[data-cd-gift-nav-next]');

      function indexFromScroll() {
        var x = stepsEl.scrollLeft;
        var best = 0;
        var bestDist = Infinity;
        for (var i = 0; i < steps.length; i++) {
          var d = Math.abs(steps[i].offsetLeft - x);
          if (d < bestDist) {
            bestDist = d;
            best = i;
          }
        }
        return best;
      }

      function setActive(idx) {
        dots.forEach(function (d) {
          var step = d.getAttribute('data-step');
          var isOn = steps[idx] && steps[idx].getAttribute('data-cd-gift-step') === step;
          d.setAttribute('aria-selected', isOn ? 'true' : 'false');
          d.classList.toggle('is-active', !!isOn);
        });
        if (prevBtn) prevBtn.disabled = idx <= 0;
        if (nextBtn) nextBtn.disabled = idx >= steps.length - 1;
      }

      function scrollToIndex(idx) {
        if (!steps[idx]) return;
        stepsEl.scrollTo({ left: steps[idx].offsetLeft, behavior: 'smooth' });
        setActive(idx);
      }

      dots.forEach(function (d) {
        d.addEventListener('click', function () {
          var step = d.getAttribute('data-step');
          var idx = steps.findIndex(function (s) {
            return s.getAttribute('data-cd-gift-step') === step;
          });
          if (idx >= 0) scrollToIndex(idx);
        });
      });

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          scrollToIndex(Math.max(0, indexFromScroll() - 1));
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          scrollToIndex(Math.min(steps.length - 1, indexFromScroll() + 1));
        });
      }

      var raf = null;
      stepsEl.addEventListener('scroll', function () {
        if (raf) return;
        raf = window.requestAnimationFrame(function () {
          raf = null;
          setActive(indexFromScroll());
        });
      });

      // Initial
      setActive(indexFromScroll());
    })(); */

    updateTriggers();
    updatePreview('wrap');
    updatePreview('card');
    updateClearBtn();

    // Multi-add on submit (only if wrap or card selected)
    var productFormEl = qs(root, 'product-form');
    var form = productFormEl ? qs(productFormEl, 'form') : null;
    if (!form) return;

    // Prevent double-binding (section can re-init on re-render/theme editor)
    if (form.__cdGiftSubmitBound) return;
    form.__cdGiftSubmitBound = true;

    // Intercept Shopify dynamic checkout button ("Buy now") which may bypass the form submit event.
    // We route it through the same multi-add flow by setting a flag and then submitting the product form.
    qsa(root, '.shopify-payment-button__button, .shopify-payment-button__button--unbranded').forEach(function (btn) {
      if (btn.__cdGiftPayBound) return;
      btn.__cdGiftPayBound = true;
      btn.addEventListener(
        'click',
        function (e) {
          if (!state.wrapVariantId && !state.cardCode) return;
          e.preventDefault();
          e.stopImmediatePropagation();
          giftRoot.__cdCheckoutIntent = true;
          try {
            form.requestSubmit();
          } catch (err) {
            // Fallback for older browsers
            var ev = new Event('submit', { bubbles: true, cancelable: true });
            form.dispatchEvent(ev);
          }
        },
        true
      );
    });


    form.addEventListener(
      'submit',
      function (evt) {
        // If no gift UI interaction happened, allow Dawn default behavior.
        // (We still support message-only if the message product is configured and the user selected a layout.)
        var msgPropsForGate = collectMessagePropsFromDOM(giftRoot);
        var messageLayoutForGate = (msgPropsForGate && msgPropsForGate['Message layout']) ? String(msgPropsForGate['Message layout']).trim() : '';
        var hasAnyGiftSelectionForGate = !!(state.wrapVariantId || state.cardCode || messageLayoutForGate);

        if (!hasAnyGiftSelectionForGate) return; // allow Dawn default

        // Require completion: wrap + card + message layout + configured message product.
        // This prevents partial gift selections from being added.
        var isGiftCompleteForGate = !!(state.wrapVariantId && state.cardCode && messageLayoutForGate && null);
        if (!isGiftCompleteForGate) {
          evt.preventDefault();
          evt.stopImmediatePropagation();

          // Inline error (preferred) with alert fallback
          var errNode = giftRoot && giftRoot.querySelector ? giftRoot.querySelector('[data-gift-error]') : null;
          var errMsg =
            (giftRoot && giftRoot.getAttribute && giftRoot.getAttribute('data-error-incomplete')) ||
            'Please select wrapping paper, card, and message options before adding to cart.';
          if (errNode) {
            errNode.textContent = errMsg;
            errNode.hidden = false;
          } else {
            window.alert(errMsg);
          }

          // Ensure the overlay is visible so the user can finish.
          try {
            if (giftRoot && typeof giftRoot.scrollIntoView === 'function') {
              giftRoot.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          } catch (e) {}

          return;
        }

        var submitter = evt.submitter || document.activeElement;
        var isCheckout = !!giftRoot.__cdCheckoutIntent;
        giftRoot.__cdCheckoutIntent = false;
        if (submitter) {
          var name = submitter.getAttribute && submitter.getAttribute('name');
          isCheckout =
            name === 'checkout' ||
            submitter.classList?.contains('shopify-payment-button__button') ||
            !!submitter.closest?.('.shopify-payment-button');
        }

        evt.preventDefault();
        evt.stopImmediatePropagation();

        var submitButton = qs(productFormEl, '[type="submit"]');
        var spinner = qs(productFormEl, '.loading__spinner');

        if (submitButton && submitButton.getAttribute('aria-disabled') === 'true') return;

        if (submitButton) {
          submitButton.setAttribute('aria-disabled', true);
          submitButton.classList.add('loading');
        }
        if (spinner) spinner.classList.remove('hidden');

        // Clear any previous inline error once we know we're complete
        try {
          var errNode2 = giftRoot.querySelector('[data-gift-error]');
          if (errNode2) {
            errNode2.textContent = '';
            errNode2.hidden = true;
          }
        } catch (e) {}

        var cart = getCart();
        var formData = new FormData(form);
        var mainId = formData.get('id');
        var qty = parseInt(formData.get('quantity') || '1', 10);
        if (!qty || qty < 1) qty = 1;

        // Gift components are limited to one per package by default.
        // (Main product quantity can still be > 1.)
        var giftQty = 1;

        var mainProps = parsePropertiesFromFormData(formData);

        // Ensure message properties are captured even if the message inputs are rendered outside the form
        // (e.g. inside an injected overlay). DOM values win over FormData.
        var msgProps = collectMessagePropsFromDOM(giftRoot);
        Object.keys(msgProps).forEach(function (k) {
          mainProps[k] = msgProps[k];
        });


        // Message presence (supports classic + To/From + Blank)
        var messageFilled = false;
        ['Greeting', 'Body', 'Sign-off', 'Signature', 'Message', 'To', 'From'].forEach(function (k) {
          var v = mainProps[k];
          if (v && String(v).trim()) messageFilled = true;
        });

        // Human-readable selection details on the main item
        if (state.wrapVariantId) {
          mainProps['Wrapping paper'] = state.wrapLabel || '';
        }
        if (state.cardCode) {
          mainProps['Greeting card'] = state.cardLabel || '';
        }

        // Helpful internal refs (hidden keys)
        mainProps._cd_has_gift = 'true';
        if (state.wrapVariantId) mainProps._cd_wrap_variant_id = state.wrapVariantId;

        var items = [
          {
            id: mainId,
            quantity: qty,
            properties: mainProps,
          },
        ];

        if (state.wrapVariantId) {
          items.push({
            id: state.wrapVariantId,
            quantity: giftQty,
            properties: Object.assign({
              _cd_parent_product_id: String(root.dataset.productId || ''),
              _cd_gift_type: 'wrap',
              'Greeting card': String(state.cardCode || '') + ' - ' + String(state.cardName || ''),
              _cd_card_code: String(state.cardCode || ''),
              _cd_card_name: String(state.cardName || ''),
              _cd_card_image: String(state.cardImage || '')
            }, collectMessagePropsFromDOM(giftRoot)),
          });
        }

        var payload = {
          items: items,
        };

        if (cart && typeof cart.getSectionsToRender === 'function') {
          payload.sections = cart.getSectionsToRender().map(function (s) {
            return s.id;
          });
          payload.sections_url = window.location.pathname;
          if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
        }

        var config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        config.headers['Content-Type'] = 'application/json';
        config.body = JSON.stringify(payload);

        fetch(routes.cart_add_url, config)
          .then(function (r) {
            return r.json();
          })
          .then(function (response) {
            if (response && response.status) {
              if (window.publish && window.PUB_SUB_EVENTS) {
                window.publish(window.PUB_SUB_EVENTS.cartError, {
                  source: 'cd-gift-options',
                  productVariantId: mainId,
                  errors: response.errors || response.description,
                  message: response.message,
                });
              }
              // Let Dawn form show generic error if present
              if (productFormEl && typeof productFormEl.handleErrorMessage === 'function') {
                productFormEl.handleErrorMessage(response.description);
              }
              return;
            }

            if (isCheckout) {
              window.location.href = '/checkout';
              return;
            }

            if (!cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (window.publish && window.PUB_SUB_EVENTS) {
              window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
                source: 'cd-gift-options',
                productVariantId: mainId,
                cartData: response,
              });
            }

            if (typeof cart.renderContents === 'function') {
              cart.renderContents(response);
            }
          })
          .catch(function (e) {
            console.error(e);
          })
          .finally(function () {
            if (submitButton) {
              submitButton.classList.remove('loading');
              submitButton.removeAttribute('aria-disabled');
            }
            if (spinner) spinner.classList.add('hidden');
          });
      },
      true // capture: run before Dawn's product-form handler
    );
  }

  function boot(scope) {
    var root = scope || document;

    // Product page
    if (!scope || scope === document) {
      qsa(document, 'product-info[data-section]').forEach(function (el) {
      var sectionId = el.getAttribute('data-section');
      if (!sectionId) return;
      initGiftUIForSection(sectionId, el);
    });
    }


    // Cart page / cart drawer
    qsa(root, '[data-cd-gift-cart][data-section-id]').forEach(function (el) {
      var sectionId = el.getAttribute('data-section-id');
      if (!sectionId) return;
      initGiftUIForSection(sectionId, el);
    });
  }

  
  // External clear request (from Cart Packages UI)
  document.addEventListener('cd:gift:clear-package', function (ev) {
    var pkgId = ev && ev.detail && ev.detail.packageId ? String(ev.detail.packageId) : '';
    if (!pkgId) return;

    cartGetJSON('/cart.js')
      .then(function (cart) {
        var updates = {};
        (cart.items || []).forEach(function (item) {
          var props = item && item.properties ? item.properties : null;
          if (!props) return;
          var t = String(props._cd_gift_type || '');
          if (String(props._cd_gift_package || '') === pkgId && (t === 'wrap' || t === 'card' || t === 'message')) {
            updates[item.key] = 0;
          }
        });
        if (Object.keys(updates).length) {
          return cartFetchJSON('/cart/update.js', { updates: updates });
        }
      })
      .catch(function (err) {
        console.error('[CD Cart Gift] Clear package failed:', err);
      });
  });

  // Expose scoped boot for packaging organizer
  try { window.CDGIFT_BOOT = boot; } catch (e) {}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }


})();
